import { FulfillmentPlanOrderGridStatus } from '../enums/fulfillmentplan-order-grid-status';

export const availableModes = {
  verifyAndPrint: 'verifyAndPrint',
  scanToPrint: 'scanToPrint',
  verify: 'verify',
};

// Keys for LocalStorage
export const SCAN_PRINTER_KEY = 'v3ScanPrinter';
export const SCAN_MODE_KEY = 'v3ScanMode';

export const scanOrderStatusDenyList = [
  FulfillmentPlanOrderGridStatus.Cancelled.name,
  FulfillmentPlanOrderGridStatus.AwaitingPayment.name,
  FulfillmentPlanOrderGridStatus.OnHold.name,
];

export const warningTypes = {
  extraProduct: 'extraProduct',
  incorrectProduct: 'incorrectProduct',
  scannedOrderNumber: 'scannedOrderNumber',
};
